(function () {
  if (window.__sheroInit) return;
  window.__sheroInit = true;

  var TRANSITION_MS = 1000;

  function setup(section) {
    if (section.__sheroReady) return;
    section.__sheroReady = true;

    var halves = section.querySelectorAll('.shero__half');
    var contentLayer = section.querySelector('.shero__content-layer');
    var dots = section.querySelectorAll('[data-shero-dot]');
    var count = contentLayer ? contentLayer.children.length : 0;
    if (count < 1) return;

    var current = 0;
    var timer = null;

    function slotsAt(i) {
      var arr = [];
      halves.forEach(function (h) {
        if (h.children[i]) arr.push(h.children[i]);
      });
      return arr;
    }

    function goTo(n) {
      n = ((n % count) + count) % count;
      if (n === current) return;
      var old = current;

      slotsAt(old).forEach(function (s) {
        s.classList.remove('is-active');
        s.classList.add('is-leaving');
      });
      slotsAt(n).forEach(function (s) {
        s.classList.remove('is-leaving');
        s.classList.add('is-active');
      });

      if (contentLayer) {
        if (contentLayer.children[old]) contentLayer.children[old].classList.remove('is-active');
        if (contentLayer.children[n]) contentLayer.children[n].classList.add('is-active');
      }

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === n);
      });

      window.setTimeout(function () {
        section.querySelectorAll('.shero__slot.is-leaving').forEach(function (s) {
          s.classList.remove('is-leaving');
        });
      }, TRANSITION_MS + 50);

      current = n;
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAuto() {
      stopAuto();
      if (section.getAttribute('data-autoplay') !== 'true') return;
      var sec = parseFloat(section.getAttribute('data-autoplay-speed')) || 6;
      timer = window.setInterval(next, sec * 1000);
    }
    function stopAuto() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    section.addEventListener('click', function (event) {
      var t = event.target;
      if (!(t instanceof Element)) return;
      if (t.closest('[data-shero-next]')) { next(); startAuto(); return; }
      if (t.closest('[data-shero-prev]')) { prev(); startAuto(); return; }
      var dot = t.closest('[data-shero-dot]');
      if (dot) { goTo(parseInt(dot.getAttribute('data-shero-dot'), 10)); startAuto(); }
    });

    section.addEventListener('mouseenter', stopAuto);
    section.addEventListener('mouseleave', startAuto);

    var startX = 0;
    section.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    section.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) {
        if (dx < 0) next(); else prev();
        startAuto();
      }
    }, { passive: true });

    startAuto();
  }

  function boot() {
    document.querySelectorAll('.shero').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector ? event.target.querySelector('.shero') : null;
    if (section) {
      section.__sheroReady = false;
      setup(section);
    }
  });
})();
